import React, { useState } from "react";
import { Box, Image, Text } from "@chakra-ui/react";

const ASButton: React.FC<{}> = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      position="relative"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      transform="translateY(10%)"
      overflow="visible" // Ensure text doesn't get clipped
    >
      {/* @ts-ignore */}
      <Image
        src="/as_icon.png"
        alt="as icon"
        height="40px"
        position="relative"
        left="50%"
        transform="translateX(-50%)"
        opacity={isHovered ? "0" : "1"}
        transition="opacity 0.5s ease-in-out"
        zIndex={1}
      />
      <Text
        position="absolute"
        left="50%"
        top="50%"
        transform={"translate(-50%, -50%)"}
        width="90px"
        opacity={isHovered ? "1" : "0"}
        transition="all 0.5s ease-in-out"
        cursor="default"
        color="#174192"
        fontWeight="medium"
        fontSize="sm"
        textAlign="center"
        whiteSpace="nowrap"
        zIndex={2}
      >
        Coming soon
      </Text>
    </Box>
  );
};

export default ASButton;
